/**
 * Password validation utility
 *
 * Requirements (SOS-314 / SOS-315 / SOS-316):
 * - Minimum 6 characters
 *
 * @param pw - The password to validate
 * @returns true if the password is valid, false otherwise
 */
export const validatePassword = (pw: string): boolean => pw.length >= 6;

/**
 * Scores password strength from 0 (empty) to 4 (strong) for the sign-up meter.
 * Heuristic only — the hard requirement stays `validatePassword` (min 6 chars).
 */
export const getPasswordStrength = (pw: string): 0 | 1 | 2 | 3 | 4 => {
  let score = 0;
  if (pw.length >= 6) score += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score += 1;
  if (/[0-9]/.test(pw)) score += 1;
  if (/[^A-Za-z0-9]/.test(pw)) score += 1;
  return score as 0 | 1 | 2 | 3 | 4;
};
